import { absurd } from 'fp-ts/function';
import CheckboxInput from './inputs/checkbox';
import DateInput from './inputs/date';
import DropdownInput from './inputs/dropdown';
import { FileInput } from './inputs/file';
import ImageInput from './inputs/image';
import RadioInput from './inputs/radio';
import RatingInput from './inputs/rating';
import TextInput from './inputs/text';
import { VideoInput } from './inputs/video';
import { jsx as _jsx } from "react/jsx-runtime";

var QuestionInput = function QuestionInput(_ref) {
  var question = _ref.question,
      questionForm = _ref.questionForm;
  var name = question.id;

  if (question.__typename === 'CheckboxQuestion') {
    return /*#__PURE__*/_jsx(CheckboxInput, {
      name: name,
      required: question.required,
      options: question.options,
      questionForm: questionForm
    });
  }

  if (question.__typename === 'DropdownQuestion') {
    return /*#__PURE__*/_jsx(DropdownInput, {
      name: name,
      required: question.required,
      options: question.options,
      questionForm: questionForm
    });
  }

  if (question.__typename === 'DateQuestion') return /*#__PURE__*/_jsx(DateInput, {
    name: name,
    required: question.required,
    questionForm: questionForm
  });

  if (question.__typename === 'LinkQuestion' || question.__typename === 'LongAnswerQuestion' || question.__typename === 'ShortAnswerQuestion') {
    return /*#__PURE__*/_jsx(TextInput, {
      name: name,
      required: question.required,
      questionType: question.__typename,
      questionForm: questionForm
    });
  }

  if (question.__typename === 'VideoUploadQuestion') return /*#__PURE__*/_jsx(VideoInput, {
    name: name,
    required: question.required,
    questionForm: questionForm
  });
  if (question.__typename === 'ImageUploadQuestion') return /*#__PURE__*/_jsx(ImageInput, {
    name: name,
    required: question.required,
    questionForm: questionForm
  });
  if (question.__typename === 'FileUploadQuestion') return /*#__PURE__*/_jsx(FileInput, {
    name: name,
    required: question.required,
    questionForm: questionForm
  });

  if (question.__typename === 'RadioButtonQuestion') {
    return /*#__PURE__*/_jsx(RadioInput, {
      name: name,
      required: question.required,
      options: question.options,
      questionForm: questionForm
    });
  }

  if (question.__typename === 'RatingQuestion') return /*#__PURE__*/_jsx(RatingInput, {
    name: name,
    required: question.required,
    questionForm: questionForm
  });
  return absurd(question);
};

export default QuestionInput;